import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import { apiRequest } from './utils/apiClient';

export interface ContactFormData {
  fullName: string;
  email: string;
  phoneNumber: string;
  company: string;
  message: string;
}

export const contactApi = {
  submitContactForm: async (
    isAuth: boolean,
    formData: ContactFormData,
    callback: () => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/support/contact/`;

    try {
      await apiRequest<void>({
        url,
        isAuth,
        method: 'POST',
        data: formData,
        contentType: 'application/json',
      });
      callback();
    } catch (error) {
      logError('Failed to submit contact form', error as Error);
    }
  },
};
